import React from "react";
import {PATH} from "../../../constants";
import {useNavigate} from "react-router-dom";

const FloatingActionButton = ({children}) => {
	const navigate = useNavigate();
	
	const handleClick = () => {
		// Add your action here
		navigate(PATH.CREATE_PRODUCT)
	};
	
	return (
		<button
			aria-label="Add item"
			className='overflow-hidden md:hidden fixed font-bold text-[8px] bottom-[110px] right-4 w-[70px] h-[70px] bg-[#197D55] border-4 border-[#F8C518] rounded-full shadow-lg flex items-center justify-center text-white'
			onClick={handleClick}
		>
			{children}
		</button>
	);
};

export default FloatingActionButton;